const TEMPLATE_NAME = 'PAD_CREATOR';

const initialState = () => ({
  loading: false,
  pad: {},
  errors: [],
  padDiagnosticCid: {
    loadedData: [],
    screenData: [],
    submitData: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = [...action.payload.errors];

      return {
        ...state,
        loading: false,
        errors
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;
      const { padDiagnosticCid } = newData;

      return {
        ...state,
        loading: false,
        padDiagnosticCid: {
          ...state.padDiagnosticCid,
          loadedData: padDiagnosticCid,
          screenData: padDiagnosticCid,
          submitData: padDiagnosticCid
        }
      };
    }

    case `${TEMPLATE_NAME}_VALIDATE_DEFINE_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_VALIDATE_DEFINE_REJECTED`: {
      const errors = [...action.payload.errors];

      return {
        ...state,
        loading: false,
        errors
      };
    }

    case `${TEMPLATE_NAME}_VALIDATE_DEFINE_FULFILLED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_SAVE_PAD`: {
      const newData = action.payload;
      const pad = newData.data;

      return {
        ...state,
        loading: false,
        pad
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
